<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="角色类型" prop="roleType">
        <a-select v-model="form.roleType" placeholder="请选择角色类型" style="width: 100%">
          <a-select-option value="USER">用户</a-select-option>
          <a-select-option value="AGENT">代理商</a-select-option>
          <a-select-option value="SITE">场地</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="提现开关" prop="withdrawalSwitch">
        <a-select v-model="form.withdrawalSwitch" placeholder="请选择提现开关" style="width: 100%">
          <a-select-option :value="0">开</a-select-option>
          <a-select-option :value="1">关</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="自动转账" prop="automaticWithdrawal">
        <a-select v-model="form.automaticWithdrawal" placeholder="请选择自动转账" style="width: 100%">
          <a-select-option :value="0">关闭</a-select-option>
          <a-select-option :value="1">打开</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="人工二次审核" prop="openAudit">
        <a-select v-model="form.openAudit" placeholder="请选择人工二次审核" style="width: 100%">
          <a-select-option :value="0">关闭</a-select-option>
          <a-select-option :value="1">打开</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="起步提现金额" prop="leastMoney">
        <a-input-number
          v-model="form.leastMoney"
          placeholder="请输入起步提现金额"
          style="width: 100%"
          :min="0"
          :precision="2"
        />
      </a-form-model-item>
      <a-form-model-item label="最大提现金额(日)" prop="dayMaxMoney">
        <a-input-number
          v-model="form.dayMaxMoney"
          placeholder="请输入最大提现金额(日)"
          style="width: 100%"
          :min="0"
          :precision="2"
        />
      </a-form-model-item>
      <a-form-model-item label="手续费" prop="fee">
        <a-input-number v-model="form.fee" placeholder="请输入手续费" style="width: 100%" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="窗口期-开始" prop="windowsTimeStart">
        <a-input-number
          v-model="form.windowsTimeStart"
          placeholder="请输入开始时间(0-23)"
          style="width: 100%"
          :min="0"
          :max="23"
        />
      </a-form-model-item>
      <a-form-model-item label="窗口期-结束" prop="windowsTimeEnd">
        <a-input-number
          v-model="form.windowsTimeEnd"
          placeholder="请输入结束时间(0-23)"
          style="width: 100%"
          :min="0"
          :max="23"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          :max-length="200"
          show-word-limit
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { editWithdrawalConfig, getWithdrawalConfigDetail } from '@/api/pressure/fund'

export default {
  name: 'FormDrawer',
  data() {
    return {
      open: false,
      submitLoading: false,
      formTitle: '新增资金提现配置',
      isEdit: false,
      form: {
        id: undefined,
        roleType: undefined,
        withdrawalSwitch: undefined,
        automaticWithdrawal: undefined,
        openAudit: undefined,
        leastMoney: undefined,
        dayMaxMoney: undefined,
        fee: undefined,
        windowsTimeStart: undefined,
        windowsTimeEnd: undefined,
        deptId: 0,
        remark: '',
      },
      rules: {
        roleType: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
        withdrawalSwitch: [{ required: true, message: '请选择提现开关', trigger: 'change' }],
        automaticWithdrawal: [{ required: true, message: '请选择自动转账', trigger: 'change' }],
        openAudit: [{ required: true, message: '请选择人工二次审核', trigger: 'change' }],
        leastMoney: [{ required: true, message: '请输入起步提现金额', trigger: 'blur' }],
        dayMaxMoney: [{ required: true, message: '请输入最大提现金额(日)', trigger: 'blur' }],
        fee: [{ required: true, message: '请输入手续费', trigger: 'blur' }],
        windowsTimeStart: [{ required: true, message: '请输入窗口期开始时间', trigger: 'blur' }],
        windowsTimeEnd: [{ required: true, message: '请输入窗口期结束时间', trigger: 'blur' }],
      },
    }
  },
  methods: {
    init(record) {
      this.reset()
      if (record && record.id) {
        this.isEdit = true
        this.formTitle = '编辑资金提现配置'
        // 获取 roleType：直接使用 record.role（格式：USER、AGENT、SITE）
        const roleType = record.role || 'USER'
        getWithdrawalConfigDetail(roleType, record.id)
          .then((res) => {
            if (res && res.data) {
              console.log(res.data.role)
              // 编辑回显：接口返回 role 字段（如："USER"），直接使用
              this.form = {
                id: res.data.id,
                roleType: res.data.role || 'USER',
                withdrawalSwitch: res.data.withdrawalSwitch,
                automaticWithdrawal: res.data.automaticWithdrawal,
                openAudit: res.data.openAudit,
                leastMoney: res.data.leastMoney,
                dayMaxMoney: res.data.dayMaxMoney,
                fee: res.data.fee,
                windowsTimeStart: res.data.windowsTimeStart,
                windowsTimeEnd: res.data.windowsTimeEnd,
                deptId: res.data.deptId || 0,
                remark: res.data.remark || '',
              }
            }
            this.open = true
          })
          .catch(() => {
            this.$message.error('获取资金提现配置详情失败')
          })
      } else {
        this.isEdit = false
        this.formTitle = '新增资金提现配置'
        // 如果传入了 role，设置默认的角色类型
        if (record && record.role) {
          this.form.roleType = record.role
        }
        this.open = true
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    reset() {
      this.form = {
        id: undefined,
        roleType: 'USER',
        withdrawalSwitch: 0,
        automaticWithdrawal: 0,
        openAudit: 0,
        leastMoney: undefined,
        dayMaxMoney: undefined,
        fee: 0,
        windowsTimeStart: 0,
        windowsTimeEnd: 23,
        deptId: 0,
        remark: '',
      }
      this.isEdit = false
    },
    onClose() {
      this.open = false
      this.reset()
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    cancel() {
      this.onClose()
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            automaticWithdrawal: this.form.automaticWithdrawal,
            dayMaxMoney: this.form.dayMaxMoney,
            fee: this.form.fee,
            leastMoney: this.form.leastMoney,
            openAudit: this.form.openAudit,
            remark: this.form.remark || '',
            roleType: this.form.roleType,
            windowsTimeEnd: this.form.windowsTimeEnd,
            windowsTimeStart: this.form.windowsTimeStart,
            withdrawalSwitch: this.form.withdrawalSwitch,
          }
          this.submitLoading = true
          editWithdrawalConfig(params)
            .then((res) => {
              if (res.success) {
                this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
                this.onClose()
                this.$emit('success')
              } else {
                this.$message.error(res.message || (this.isEdit ? '编辑失败' : '新增失败'))
              }
              this.submitLoading = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 10;
}
</style>
